import script from "./BaseFileUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFileUpload.vue?vue&type=script&setup=true&lang=js"

import "./BaseFileUpload.vue?vue&type=style&index=0&id=dc038cc6&lang=scss"

const __exports__ = script;

export default __exports__